import { useSubscriptionBillingHistory } from '@forwardflow/hooks/customHooks'
import Icon from '@forwardflow/ui/Icons'
import { Link } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import { Spinner } from '@forwardflow/ui/Spinner'
import dayjs from 'dayjs'

export const PreviousBillings = () => {
   const [page, setPage] = useState(1)
   const [hasMore, setHasMore] = useState(true)
   const [billingHistory, setBillingHistory] = useState<any[]>([])
   const tableRef = useRef<HTMLDivElement>(null)
   const ITEMS_PER_PAGE = 10

   const { data, isLoading } = useSubscriptionBillingHistory({
      page,
      limit: ITEMS_PER_PAGE,
   })
   useEffect(() => {
      if (data?.data) {
         setBillingHistory((prev) => [...prev, ...data.data])
         if (data?.data?.length < ITEMS_PER_PAGE) {
            setHasMore(false)
         }
      }
   }, [data])

   const handleScroll = () => {
      if (tableRef.current && !isLoading && hasMore) {
         const { scrollTop, scrollHeight, clientHeight } = tableRef.current
         if (scrollTop + clientHeight >= scrollHeight - 20) {
            setPage((prev) => prev + 1)
         }
      }
   }

   useEffect(() => {
      const currentRef = tableRef.current
      if (currentRef) {
         currentRef.addEventListener('scroll', handleScroll)
         return () => currentRef.removeEventListener('scroll', handleScroll)
      }
   }, [isLoading, hasMore])

   const hasNoBillings = !isLoading && billingHistory.length === 0

   return (
      <div className="flex-1 my-12 pb-12">
         <p className="mb-5 font-medium">Previous Billings</p>
         <div ref={tableRef} className="max-h-[600px] overflow-y-auto">
            <table className="w-full bg-[#474747]/10 rounded-xl">
               <thead className="sticky top-0 z-10 bg-[#2e2a39]">
                  <tr className="text-[14px] font-medium bg-[#474747]/10 text-white/70">
                     <th className="py-6 text-left px-9 sticky top-0 bg-[#474747]/10">
                        Month
                     </th>
                     <th className="py-6 text-left px-9 sticky top-0 bg-[#474747]/10">
                        Description
                     </th>
                     <th className="py-6 text-left px-9 sticky top-0 bg-[#474747]/10">
                        Total Charge
                     </th>
                     <th className="py-6 px-9 sticky top-0 bg-[#474747]/10"></th>
                  </tr>
               </thead>
               <tbody>
                  {billingHistory.map((item, index) => (
                     <tr key={index} className="font-medium">
                        <td className="py-6 px-9">
                           {dayjs(item?.paidAt).format('D MMM, YYYY')}
                        </td>
                        <td className="py-6 max-w-80 px-9">
                           {item?.description}
                        </td>
                        <td className="py-6 px-9">$ {item?.amountPaid}</td>
                        <td className="py-6 px-9">
                           <Link
                              to={item?.invoicePdfUrl}
                              className="flex items-center gap-2"
                           >
                              <Icon name="Download" className="w-5 h-5" />
                           </Link>
                        </td>
                     </tr>
                  ))}
                  {hasNoBillings && (
                     <tr>
                        <td colSpan={3} className="py-12 text-center text-white/70">
                           No billing history available
                        </td>
                     </tr>
                  )}
               </tbody>
            </table>
            {isLoading && (
               <div className="flex justify-center py-4">
                  <Spinner className="w-8 h-8" />
               </div>
            )}
         </div>
      </div>
   )
}
